import { FunnelStepSettingTabsEnum } from 'modules/funnels/funnel/enums/funnel-step-setting-tabs-enum'
import { useRouter } from 'next/router'

type RouterQuery = {
  step?: string
  tab?: FunnelStepSettingTabsEnum
  funnelId?: string
  [key: string]: string | string[] | undefined
}

export function useUpdateFunnelStepQuery() {
  const router = useRouter()
  const query = router.query as RouterQuery

  const updateFunnelStepQuery = (
    funnelStepId: number,
    funnelStepTab?: FunnelStepSettingTabsEnum,
  ) => {
    if (!router.isReady) return

    const currentStep = query.step ? Number(query.step) : null
    if (currentStep === funnelStepId && (!funnelStepTab || query.tab === funnelStepTab)) {
      return
    }

    const newQuery = {
      ...query,
      step: String(funnelStepId),
      ...(funnelStepTab && { tab: funnelStepTab }),
    }

    router
      .replace(
        {
          pathname: router.pathname,
          query: newQuery,
        },
        undefined,
        { shallow: true },
      )
      .catch(e => {
        if (!e.cancelled) console.error(e)
      })
  }

  const clearFunnelStepTabQuery = () => {
    if (!query.step) return
    updateFunnelStepQuery(Number(query.step))
  }

  return {
    updateFunnelStepQuery,
    clearFunnelStepTabQuery,
  }
}
